const FinancialEventStatuses = [
    { value: "pending", text: "Pending" },
    { value: "complete", text: "Complete" },
];

export default FinancialEventStatuses;
